import { ENV } from "../utils";

export class ActionPlan {
  baseApi = ENV.BASE_API;

  async getActionPlans(accessToken, active = true, company) {
    const url = `${this.baseApi}/action-plans?active=${active}${company ? `&company=${company}` : ""}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getActionPlanByAccident(accessToken, accidentId) {
    const url = `${this.baseApi}/action-plans?accidentId=${accidentId}&active=true`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return Array.isArray(result) ? (result[0] || null) : null;
  }

  async getActionPlanByLegalRequirement(accessToken, requisitoLegalId) {
    const url = `${this.baseApi}/action-plans?requisitoLegalId=${requisitoLegalId}&active=true`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return Array.isArray(result) ? (result[0] || null) : null;
  }

  async getActionPlan(accessToken, id) {
    const response = await fetch(`${this.baseApi}/action-plan/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createActionPlan(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-action-plan`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateActionPlan(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-action-plan/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteActionPlan(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-action-plan/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async uploadFile(accessToken, id, formData) {
    const response = await fetch(`${this.baseApi}/action-plan/${id}/upload-file`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getFile(accessToken, fileName) {
    const response = await fetch(`${this.baseApi}/action-plan-file/${fileName}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }

  async deleteFile(accessToken, id, fileName) {
    const response = await fetch(`${this.baseApi}/action-plan/${id}/delete-file`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ fileName }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async triggerEscalation(accessToken) {
    const response = await fetch(`${this.baseApi}/action-plans/run-escalation`, {
      method: "POST",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
